<template lang="pug">
	Transition(name="snackbar-fade")
		CustomSnackbar.snackbar-undo(v-if="value" :show='value' @close="close")
			.snackbar-content
				p.item-header {{ header }}
				p.item-text {{ message }}
				button.button-undo(@click="onUndoClick")
					IconUndo.undo-icon
					p.undo-text Undo
</template>

<script>
import CustomSnackbar from '@/components/CustomSnackbar';
import IconUndo from '@/components/IconUndo';

export default {
  name       : 'undo-snackbar',
  components : {
    CustomSnackbar,
    IconUndo
  },

  data() {
    return {
      timeoutHandler : null
    };
  },

  props : {
    // Controls visibility through v-model
    value  : Boolean,
    header : {
      type    : String,
      default : 'Item Removed'
    },
    message : {
      type    : String,
      default : 'You successfully removed a course from Your Plan'
    },
    // How many milliseconds the snackbar should appear for
    timeout : {
      type    : Number,
      default : 0
    }
  },

  watch : {
    value : {
      immediate : true,
      handler( newValue ) {
        if ( newValue && this.timeout > 0 ) {
          this.timeoutHandler = setTimeout(
            () => {
              this.close();
            },
            this.timeout
          );
        }
        else {
          clearTimeout( this.timeoutHandler );
        }
      }
    }
  },

  methods : {
    onUndoClick() {
      this.$emit( 'undo' );
    },

    close() {
      this.$emit( 'input', false );
    }
  }
};
</script>

<style lang="scss" scoped>
.snackbar-fade-enter,
.snackbar-fade-leave-to {
    opacity: 0;
	transform: translateY(100%) scale(0);
}

.snackbar-fade-enter-active,
.snackbar-fade-leave-active {
    transition: all 0.4s ease;
}

.snackbar-undo::v-deep {
	position: fixed;
	transform-origin: left;
	bottom: 20px;
	left:   20px;

	.snackbar-content {
		.item-header {
			font-weight: 600;
			font-size: 18px;
		}
		.item-text {
			font-size: 16px;
		}
		.button-undo {
			cursor: pointer;
			margin-top: 8px;
			border: none;
			background-color: rgba(38, 104, 208, 0.2);
			border-radius: 20px;
			padding: 4px 13px;
			color: #1C4587;
			display: flex;
			align-items: center;
			.undo-icon {
				width: 16px;
			}
			.undo-text {
				font-size: 16px;
				margin-left: 10px;
			}
		}
	}
}
</style>
